module.exports = __webpack_public_path__ + "media/images/account-icon-48061d9bcde35764ff9bc54b33192866.png";